export default __webpack_public_path__ + "static/media/Tommy-Benson.805881c3.jpg";